export default "__VITE_ASSET__8dP0R8bt__"